import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
GenericModal.propTypes = {
    children: PropTypes.object,
    expanded: PropTypes.bool,
    onOutSideClick: PropTypes.func,
    modalClasses: PropTypes.string
};
export default function GenericModal(_a) {
    var _b = _a.children, children = _b === void 0 ? {} : _b, _c = _a.expanded, expanded = _c === void 0 ? false : _c, _d = _a.onOutSideClick, onOutSideClick = _d === void 0 ? function () { } : _d, _e = _a.modalClasses, modalClasses = _e === void 0 ? '' : _e;
    var ref = useRef(null);
    useEffect(function () {
        function handleClick(_a) {
            var target = _a.target;
            if (ref.current && !ref.current.contains(target)) {
                onOutSideClick();
            }
        }
        document.addEventListener('mousedown', handleClick);
        return function () { return document.removeEventListener('mousedown', handleClick); };
    }, [onOutSideClick]);
    return (React.createElement("div", { className: clsx('lightbox', expanded && 'active') },
        React.createElement("div", { className: "modal ".concat(modalClasses) },
            React.createElement("div", { className: "modal__inner", ref: ref }, children))));
}
